const MISSION_PREFERENCES = {
  ALLOW_EDIT: 'allowEdit',
};

export default angular
  .module('sfMobile.constants.mission-preferences', [])
  .constant('SF_MISSION_PREFERENCES', MISSION_PREFERENCES).name;
